module.exports = __webpack_public_path__ + "static/media/aw.eb2b029d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/aw.svg
// module id = 55
// module chunks = 0